import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontFamilies, fontWeights, fontSizes, lineHeights, palette, siteMediumWidth,
}: Theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '1.5rem',
    borderRadius: '1rem',
    boxShadow: '3px 4px 13px 0 rgba(5, 41, 103, 0.1)',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: '1rem',
      padding: '2rem',
    },
    [breakpoints.up('lg')]: {
      maxWidth: siteMediumWidth,
    },
  },
  container: {
    margin: '1.25rem 0 1.5rem',
    [breakpoints.up('md')]: {
      margin: '2.5rem 0 3.5rem',
    },
  },
  sectionTitle: {
    margin: '0 0 0.75rem',
    fontWeight: fontWeights.medium,
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      margin: '0 0 0.5rem',
      fontSize: '1.75rem',
      lineHeight: 1.35,
    },
  },
  description: {
    margin: '0 0 1.5rem',
    fontSize: fontSizes.xs,
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  button: {
    position: 'static',
    display: 'flex',
    width: '100%',
    marginTop: '1.5rem',
    padding: '18px 1.5rem',
    border: `1px solid ${palette.text.primary}`,
    borderRadius: 60,
    color: palette.text.primary,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
    textTransform: 'uppercase',
    [breakpoints.up('md')]: {
      maxWidth: 174,
      marginTop: 24,
      padding: '1.25rem 1.5rem',
    },
    [breakpoints.up(893)]: { // fix absolute text position
      marginTop: 36,
    },
    '& span': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      padding: '1.5rem 1.5rem 2rem',
      [breakpoints.up('md')]: {
        justifyContent: 'flex-start',
        padding: '2rem 2rem 2.5rem 3.5rem',
      },
    },
  },
  img: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: '22.5rem',
      objectFit: 'contain',
    },
  },
}));
